import { Image, View, YStack } from "tamagui";
import Blinking from "./Blinking";
import { Body } from "./Body";
import { Title } from "./Title";

export const FullScreenLoading: React.FC<{
  subtitle?: string;
}> = ({ subtitle }) => {
  return (
    <View height="100vh" alignItems="center" justifyContent="center">
      <YStack
        gap="$large"
        maxWidth={600}
        alignItems="center"
        padding="$space.medium"
      >
        <Image
          objectFit="contain"
          height={32}
          width={171}
          source={require("../../assets/planira.png")}
        />
        <Blinking>
          <YStack gap="$small" alignItems="center">
            <Title>Loading Planira...</Title>
            <Body>We're loading Planira, hold tight!</Body>
            {!!subtitle && <Body muted>({subtitle})</Body>}
          </YStack>
        </Blinking>
      </YStack>
    </View>
  );
};
